export const useProgressPro = (startTime: string, endTime: string) => {
  const start = new Date(startTime).getTime();
  const end = new Date(endTime).getTime();
  const now = Date.now();

  const timeTotal = end - start;
  const timeLeft = now - start;

  const progress = 100 - Math.min((timeLeft / timeTotal) * 100, 100);

  const daysLeft = Math.floor((timeTotal - timeLeft) / (1000 * 60 * 60 * 24));

  return { progress, daysLeft };
};
